import { useEffect } from 'react';

type UseScriptOptions = {
  onLoad?: (e, script) => void;
}

export default function useScript(url: string, attributes: Object = {}, options: UseScriptOptions = {}) {
  useEffect(() => {
    const script = document.createElement('script');

    script.addEventListener('load', (e) => options.onLoad && options.onLoad(e, script));
    script.src = url;

    for (const i in attributes) {
      script[i] = attributes[i] || 'true';
    }

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [url]);
}
